import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ResumeDatabaseBanner } from 'components/Banners/ResumeDatabaseBanner';
import { SalarySurveyBanner } from 'components/Banners/SalarySurveyBanner';
import { ClientOnly } from 'containers/ClientOnly';
import { setAdTypeOnPageLoad } from 'modules/main/store/ducks/layout';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

import { BannerAdsBox } from './BannerAds.styled';

export function BannerAds() {
  const adTypeOnPageLoad = useMainSelector(
    (state) => state.layout.adTypeOnPageLoad,
  );

  const hideSalarySurveyAd = useMainSelector(
    (state) => state.layout.hideSalarySurveyAd,
  );

  const userEnvironment = useUserEnvironment();
  const { isUserLoaded, isEnvironmentLoaded } = userEnvironment;
  const dispatch = useMainDispatch();
  const location = useLocation();

  const hasSalarySurveyBanner =
    !location.pathname.includes('/salaries') &&
    !hideSalarySurveyAd &&
    promoteSalarySurvey({
      userEnvironment,
      allowDismissal: true,
    });

  useEffect(() => {
    if (
      isUserLoaded &&
      isEnvironmentLoaded &&
      adTypeOnPageLoad !== 'SALARY_SURVEY' &&
      hasSalarySurveyBanner
    ) {
      dispatch(setAdTypeOnPageLoad('SALARY_SURVEY'));
    }
  }, [
    isUserLoaded,
    isEnvironmentLoaded,
    dispatch,
    adTypeOnPageLoad,
    hasSalarySurveyBanner,
  ]);

  const hasResumeDatabaseBanner =
    !hasSalarySurveyBanner &&
    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
    !['GRAD_FAIRS', 'SALARY_SURVEY'].includes(adTypeOnPageLoad) &&
    promoteResumeDatabase({
      userEnvironment,
      allowLoggedOut: true,
    });

  useEffect(() => {
    if (
      isUserLoaded &&
      isEnvironmentLoaded &&
      adTypeOnPageLoad !== 'RESUME_DB' &&
      hasResumeDatabaseBanner
    ) {
      dispatch(setAdTypeOnPageLoad('RESUME_DB'));
    }
  }, [
    isUserLoaded,
    isEnvironmentLoaded,
    adTypeOnPageLoad,
    hasResumeDatabaseBanner,
    dispatch,
  ]);

  return (
    <BannerAdsBox
      data-qa-id="ads-container"
      mt={[60, null, null, 0]}
      mb={[-60, null, null, 0]}
    >
      <ClientOnly>
        {hasResumeDatabaseBanner && <ResumeDatabaseBanner />}
        {hasSalarySurveyBanner && <SalarySurveyBanner />}
      </ClientOnly>
    </BannerAdsBox>
  );
}
